<template>
  <div>
    <vuex-breadcrumb></vuex-breadcrumb>
    <product-item-create
      :ams_template="ams_template"
      :reroute="reroute"
    ></product-item-create>
  </div>
</template>

<script>
import VuexBreadcrumb from './VuexBreadcrumb.vue'
import ProductItemCreate from './ProductItemCreate.vue'

export default {
  components: {
    VuexBreadcrumb,
    ProductItemCreate
  },
  props: {
    reroute: {
      Type: Boolean,
      default: true
    },
    ams_template: {
      Type: Object
    }
  }
}
</script>